import { create } from 'zustand';
import { ILogin } from '../models/login.model';
import { USER_DATA } from '../../../constants/localStorageKey';
import getOperatingSystem from '../../../utils/get-operating-system';
import getDeviceInfo from '../../../utils/get-device-info';
import axios from 'axios';
import { apiBase, apiKey } from '../../../constants/apiKey';
import { ApiPath } from '../../../constants/apiPath';
import { axiosErrorMessage } from '../../../utils/error-message';
import { storeTokens } from '../../../utils/token-store';

const LoginController = (set: any) => ({
  loading: false,
  errorMessage: '',

  handleSubmit: async (login: ILogin) => {
    try {
      set(() => ({ loading: true, errorMessage: '' }));

      const userAgent = navigator.userAgent;
      const body = {
        username: login.username,
        password: login.password,
        device_id: 'ABC-123-XYZ',
        device_info: getDeviceInfo(userAgent),
        operating_system: getOperatingSystem(userAgent),
        login_version: '1.2.3',
        login_type: 'normal',
      };

      const loginResponse = await axios.post(`${apiBase}${ApiPath.auth.login}`, body);
      const accessToken: string = loginResponse?.data?.accessToken;
      const refreshToken: string = loginResponse?.data?.refreshToken;

      if (accessToken) {
        const getUserResponse = await axios.post(
          `${apiBase}${ApiPath.auth.getUserData}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              apikey: apiKey,
            },
          }
        );
        if (getUserResponse?.data) {
          const userData = getUserResponse?.data;
          if (userData) {
            localStorage.setItem(USER_DATA, JSON.stringify({ userData }));
          } else {
            set(() => ({ errorMessage: 'Failed to fetch user data' }));
          }
          storeTokens(accessToken, refreshToken);
          set(() => ({ loading: false }));
          window.location.href = '/';
        }
      }
    } catch (error: any) {
      set(() => ({ errorMessage: axiosErrorMessage({ error }), loading: false }));
    }
  },
});

const loginController = create(LoginController);

export default loginController;
